import React from "react";
import FormUI, { type FormItemProps } from "@/componentsUI/Form";
const FromItem = FormUI.Item;


const FromItemPlus = (props: FormItemProps) => {
    return <FromItem
        {...props}
    />
}


export default FromItemPlus
